const mediaPopup = document.getElementById('media-popup');
const close = document.getElementById('close-media-popup');
const image = document.getElementById('media-popup-image');
const slider = document.getElementById('item_slider');

const nextImage = () => {
    const active = document.querySelector('.i_slide.active');
    
    const newScroll = slider.scrollLeft + slider.offsetWidth;
    
    if(newScroll < slider.scrollWidth) {
        slider.scrollLeft = newScroll;
    } else {
        slider.scrollLeft = 0;
    }
    
    active.classList.remove('active');
    
    let next = active.nextElementSibling;
    if(!next) next = slider.firstElementChild; // Loop
    next.classList.add('active');
}

document.getElementById('slider_next').addEventListener('click', nextImage);

const prevImage = () => {
    const active = document.querySelector('.i_slide.active');
    
    const newScroll = slider.scrollLeft - slider.offsetWidth;
    
    if(newScroll >= 0) {
        slider.scrollLeft = newScroll;
    } else {
        slider.scrollLeft = slider.scrollWidth - slider.offsetWidth;
    }
    
    active.classList.remove('active');
    
    let prev = active.previousElementSibling;
    if(!prev) prev = slider.lastElementChild; // Loop
    prev.classList.add('active');
}

document.getElementById('slider_prev').addEventListener('click', prevImage);

const openImage = (e) => {
    // Do nothing for small screens
    if(window.innerWidth < 640) return;
    
    // Unhide popup
    mediaPopup.classList.remove('hidden');
    
    // Find target media inside popup
    let target = e.target.getAttribute('data');
    
    // Videos are wrapped in a div, so get parent data attr if none present on clicked element
    if(!target) target = e.target.parentElement.getAttribute('data');
    console.log(target);
    
    // Get selected element from popup & set as active
    const selected = document.getElementById(target);
    
    // Get offset from edge of scrollbox
    const offset = selected.offsetLeft;
    console.log(offset);
    
    // Set scrollbox to offset & set selected as active
    slider.scrollLeft = offset;
    selected.classList.add('active');
}

const closeImage = () => {
    document.querySelector('.i_slide.active').classList.remove('active');
    mediaPopup.classList.add('hidden');
}

document.querySelectorAll('.media-thumb').forEach(img => img.addEventListener('click', openImage));
close.addEventListener('click', closeImage);


// Scroll indicator code
const gallery = document.getElementById('media-gallery');
const indicator = document.getElementById('scroll-indicator');
const track = document.getElementById('scroll-track');

gallery.addEventListener('scroll', () => {
    const scrollPercentage = (gallery.scrollLeft / (gallery.scrollWidth - gallery.offsetWidth)) * 100;
    const trackWidth = track.scrollWidth - indicator.offsetWidth;
    indicator.style.transform = `translateX(${(scrollPercentage / 100) * trackWidth}px)`;
});